/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react'
import { DateCell, Badge } from '@fortressiq/fiq-ds'
import { useHeaderDispatch } from 'app/header/HeaderContext'
import TrinityTable from 'components/TrinityTable'
import LinkVerification from './subComponents/LinkVerification'
import AddIpAddress from './subComponents/AddIpAddress'
import IpWhitelistToggle from './subComponents/IpWhitelistToggle'
import IpDisableButton from './subComponents/IpDisableButton'
import RefreshTableButton from './subComponents/RefreshTableButton'

const sortKeyMap = {
  ipAddress: 'ip_address',
  active: 'active',
  verified: 'verified',
  verifiedAt: 'verified_at',
  verificationTokenExpiredAt: 'verification_token_expired_at',
  disabledAt: 'disabled_at',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
}

const IpAddressList = () => {
  const hiddenColumns = JSON.parse(localStorage.getItem('ipaddress-table-hidden-columns-1')) || []
  const [reFetch, setReFetch] = useState(0)
  const [verficationLink, setVerificationLink] = useState([])
  const [whitelistStatus, setWhitelistStatus] = useState(true)
  const [ipToggleStatus, setIpToggleStatus] = useState(true)
  const [sortBy, setSortBy] = useState('active')

  const getIpWhitelistingStatus = data => {
    setWhitelistStatus(data.ipWhitelistEnabled)
    setIpToggleStatus(data.ipWhitelistEnabled)
  }
  /* istanbul ignore next */
  const handleReFetch = () => {
    setReFetch(reFetch + 1)
  }
  const headerDispatch = useHeaderDispatch()

  /* istanbul ignore next */
  const columns = [
    {
      Header: 'IP Address',
      accessor: 'ipAddress',
    },
    {
      Header: 'Created By',
      accessor: 'createdByName',
      disableSortBy: true,
    },
    {
      Header: 'Modified By',
      accessor: 'modifiedByName',
      disableSortBy: true,
    },
    {
      Header: 'Status',
      accessor: 'active',
      Cell: ({ value }) => (
        <React.Fragment>
          <Badge status={value ? 'success' : 'danger'} /> {value ? 'Active' : 'Inactive'}
        </React.Fragment>
      ),
    },
    {
      Header: 'Verified',
      accessor: 'verified',
      disableSortBy: true,
      Cell: ({ row: { original } }) => {
        const matchedId = verficationLink.find(val => val.id === original.id && val.url) || false

        return (
          <LinkVerification
            matchedId={matchedId}
            rowData={original}
            verificationLinksData={verficationLink}
            setVerificationLink={setVerificationLink}
            handleReFetch={handleReFetch}
            whitelistStatus={whitelistStatus}
            setSortBy={setSortBy}
          />
        )
      },
    },
    {
      Header: 'Verified At',
      accessor: 'verifiedAt',
      Cell: ({ value }) => (value ? <DateCell timestamp={value} /> : 'NA'),
    },
    {
      Header: 'Verification Token Expired At',
      accessor: 'verificationTokenExpiredAt',
      Cell: ({ value }) => (value ? <DateCell timestamp={value} /> : 'NA'),
    },
    {
      Header: 'Disabled At',
      accessor: 'disabledAt',
      Cell: ({ value }) => (value ? <DateCell timestamp={value} /> : 'NA'),
    },
    {
      Header: 'Error',
      accessor: 'error',
      disableSortBy: true,
    },
    {
      Header: 'Created At',
      accessor: 'createdAt',
      width: 130,
      maxWidth: 130,
      Cell: ({ value }) => (value ? <DateCell timestamp={value} /> : 'NA'),
    },
    {
      Header: 'Updated At',
      accessor: 'updatedAt',
      width: 130,
      maxWidth: 130,
      Cell: ({ value }) => (value ? <DateCell timestamp={value} /> : 'NA'),
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      align: 'center',
      disableSortBy: true,
      maxWidth: 64,
      Cell: ({ row: { original } }) => <IpDisableButton rowData={original} handleReFetch={handleReFetch} />,
    },
  ]

  useEffect(() => {
    headerDispatch({
      type: 'set',
      title: 'Manage IP Allow List',
      heading: 'Manage IP Allow List',
    })

    return () => {
      headerDispatch({
        type: 'clear',
      })
    }
  }, [headerDispatch])

  return (
    <TrinityTable
      toolbarActions={[
        <RefreshTableButton handleReFetch={handleReFetch} key='Refresh Button' />,
        <AddIpAddress
          key='Add Ip Address'
          handleReFetch={handleReFetch}
          whitelistStatus={whitelistStatus}
          setSortBy={setSortBy}
        />,
        <IpWhitelistToggle
          key='Ip Whitelist Toggle'
          ipToggleStatus={ipToggleStatus}
          whitelistStatus={whitelistStatus}
          handleReFetch={handleReFetch}
          setIpToggleStatus={setIpToggleStatus}
          setWhitelistStatus={setWhitelistStatus}
        />,
      ]}
      reFetch={reFetch}
      sortKeyMap={sortKeyMap}
      defaultSortKey={sortBy}
      tableId='ipaddress-table'
      columns={columns}
      url='/ip_addresses'
      dataKey='ipAddresses'
      defaultHideColumns={hiddenColumns.length ? ['verificationTokenExpiredAt', 'error'] : []}
      getTableData={getIpWhitelistingStatus}
    />
  )
}

export default IpAddressList
